<script lang="ts">
import type { RegisteredComponent } from '@builder.io/sdk-svelte';
import { Content, isPreviewing } from '@builder.io/sdk-svelte';
import { CUSTOM_COMPONENTS } from '../../CustomComponents.js';
import { BUILDER_PUBLIC_API_KEY } from '../../config/apiKeys.js';

// biome-ignore lint/suspicious/noExplicitAny: Data type from +page.server.js
let { data }: { data: any } = $props();

// shortcut to the actual content
let pageContent = $derived(data.builderProps.content?.data || {});

// we want to show unpublished content when in preview mode.
let canShowContent = $derived(pageContent || isPreviewing());
let isServicesIndexPage = $derived(pageContent?.url === '/services');
</script>

{#if canShowContent}
    <!-- force re-rendering of `Content` on client-side navigation -->
    {#key pageContent}
        <!-- Render builder content with all required props -->
        <div
            class="container builder-content container--id-{data?.builderProps?.content?.id}"
            class:container--services-index={isServicesIndexPage}
        >
            <Content
                model="page"
                content={data.builderProps.content}
                apiKey={BUILDER_PUBLIC_API_KEY}
                customComponents={CUSTOM_COMPONENTS as RegisteredComponent[]}
                isNestedRender={!isPreviewing()}
            />
        </div>
    {/key}
{:else}
    Content Not Found
{/if}
